import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { School, Building2, Layers, DoorOpen } from "lucide-react";

export default function OwnerCommunities() {
  const [communities, setCommunities] = useState([]);
  useEffect(() => { http.get("/ops/communities").then(({ data }) => setCommunities(data)); }, []);

  return (
    <div className="space-y-6" data-testid="owner-communities">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Communities</div>
        <h1 className="font-display text-3xl font-bold text-primary">Apartment Communities</h1>
        <p className="text-sm text-muted-foreground mt-1">{communities.length} community(ies) across all universities.</p>
      </div>

      {communities.length === 0 && (
        <Card className="border-dashed"><CardContent className="p-10 text-center text-muted-foreground">No communities yet.</CardContent></Card>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {communities.map((c) => (
          <Card key={c.id} className="border-border/60"><CardContent className="p-6">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-display font-semibold text-primary text-lg">{c.name}</div>
                <div className="text-xs text-muted-foreground">{c.university?.name || "—"}</div>
                <div className="text-xs text-muted-foreground">{c.address || ""}</div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <Badge variant="outline">{c.billing_model}</Badge>
                {c.active_contract && <Badge className="bg-secondary/10 text-secondary border border-secondary/20">Under contract</Badge>}
              </div>
            </div>
            <div className="grid grid-cols-4 gap-3 mt-4 text-center border-t pt-4">
              <MiniStat n={c.metrics.buildings} l="Buildings" i={<Building2 size={14} />} />
              <MiniStat n={c.metrics.units} l="Units" i={<Layers size={14} />} />
              <MiniStat n={c.metrics.bedrooms} l="Bedrooms" i={<DoorOpen size={14} />} />
              <MiniStat n={`${c.metrics.occupancy_pct}%`} l="Occupancy" />
            </div>
            {c.active_contract && (
              <div className="mt-3 text-xs bg-secondary/5 border border-secondary/20 rounded-lg p-2">
                <b>{c.active_contract.title}</b>
                <div className="text-muted-foreground">MRR ${(c.active_contract.mrr_cents / 100).toLocaleString()} · {c.active_contract.status}</div>
              </div>
            )}
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
}

function MiniStat({ n, l, i }) {
  return (
    <div>
      {i && <div className="text-muted-foreground mb-1 flex justify-center">{i}</div>}
      <div className="font-display font-bold text-lg text-primary">{n}</div>
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{l}</div>
    </div>
  );
}
